import qs from 'querystring'

import _ from 'underscore'
import Api from '../lib/request'
import {
  itemList,
} from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import STATUS_CODE from '../constant/status_code'
import { toLogin } from '../util/function'
import { checkState } from '@src/api/'

const emptyListData = {
  page: {
    total: 0,
  },
  list: [],
}

const getProductAttrsInfo = (productId) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}?productId=${productId}`
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.product.attrs-batch',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      return resolve(data.data)
    })
  })
}

const getHomeRecommendItems = () => new Promise((resolve, reject) => {
  Api.get('/api/recommend/home')
    .then((data) => {
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})

const getDetail = id => new Promise((resolve, reject) => {
  Api.get(`/api/item?id=${id}`)
})

const getItemList = (page, count) => new Promise((resolve, reject) => {
  // mock
  return resolve(itemList.data)
  Api.get(`/api/item/list?page=${page}&count=${count}`)
})


const getItemDetail = requestData => new Promise((resolve, reject) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}`
  // Api.get('http://localhost:3000/productInfo', {
  Api.get(url, {
    params: requestData,
    headers: {
      'X-Host': 'mall.product.info',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      if (data.status === STATUS_CODE.PRODUCTS_NOT_EXIST) {
        return resolve(STATUS_CODE.PRODUCTS_NOT_EXIST)
      }
      return reject(new Error(data.msg))
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getItemDesc = id => new Promise((resolve, reject) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}?productId=${id}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.desc',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getItemAttr = (options) => {
  const query = _.isEmpty(options) ? '' : `?${qs.stringify(options)}`
  return new Promise((resolve, reject) => {
    const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.product.attrs',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

//获取组合商品子商品清单
const getChildProductList = (options) => {
  const query = _.isEmpty(options) ? '' : `?${qs.stringify(options)}`

  return new Promise((resolve, reject) => {
    const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.product.child-prodcuct-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}


const getProductCityList = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.cityList',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status == 6003) {
        return resolve([])
      } else if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
const checkDelivery = data => new Promise((resolve, reject) => {
  data = JSON.stringify(data)
  const url = COOKIECONSTANT.REQUEST_HOST

  Api.post(url, data, {
    headers: {
      // 'X-Host': 'mall.product.delivery-check',
      'X-Host': 'mall.product.delivery-check.v3',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      // checkState(data,reject(data))
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
const queryAreaInfoByIds = data => new Promise((resolve, reject) => {
  data = JSON.stringify(data)
  const url = COOKIECONSTANT.REQUEST_HOST

  Api.post(url, data, {
    headers: {
      'X-Host': 'mall.app-public.city.batch-query',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const verifyOrder = options => new Promise((resolve, reject) => {
  const url = COOKIECONSTANT.REQUEST_HOST
  const op = JSON.stringify(options)
  Api.post(url, op, {
    headers: {
      'X-Host': 'mall.order.verify.v2',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status === 6666) {
      return toLogin()
    }
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getStoreList = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.store.list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyListData)
      }
      if (data.status !== 0) {
        return reject(data)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
const getStoreDetail = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.store.detail',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const getSuitableCoupon = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.suitable-coupon',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const setCouponStatus = data => new Promise((resolve, reject) => {
  const url = COOKIECONSTANT.REQUEST_HOST
  const op = JSON.stringify(data)
  Api.post(url, op, {
    headers: {
      'X-Host': 'mall.product.acquire-coupon',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status === 6666) {
      return toLogin()
    }
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve('ok')
  }, (e) => {
    reject(e)
  })
})
// 为您推荐的商品获取
const getRelatedProduct = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.related-product',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
// 看了又看的商品获取
const getLookRelatedProduct = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.product.related-product',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

// 获取套餐详情
const getSchemeList = options => new Promise((resolve, reject) => {
  const url = COOKIECONSTANT.REQUEST_HOST
  const op = JSON.stringify(options)
  Api.post(url, op, {
    headers: {
      'X-Host': 'mall.examine.tool.scheme-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

/* yeoman-template-point-1 */
export default {
  getProductAttrsInfo,
  getHomeRecommendItems,
  getDetail,
  getItemList,
  getItemDetail,
  getItemDesc,
  getItemAttr,
  getChildProductList,
  getProductCityList,
  verifyOrder,
  checkDelivery,
  queryAreaInfoByIds,
  getStoreList,
  getStoreDetail,
  getSuitableCoupon,
  setCouponStatus,
  getRelatedProduct,
  getLookRelatedProduct,
  getSchemeList,
  /* yeoman-template-point-2 */
}
